import React from 'react';
import Page from 'App/components/Page';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import AssessmentPublisher from './AssessmentPublisher';

function AssessmentPublisherPage() {
    return (
        <Page title="Assessment Publisher" showPageTitle permissionType={PERMISSION_TYPES.ASSESSMENT_PUBLISHER}>
            <AssessmentPublisher />
        </Page>
    );
}

export default AssessmentPublisherPage;
